import * as actionTypes from '../actions/actionTypes';

export default function getDarkTitleBarFlag(state = {}, action) {
  switch(action.type){
    case actionTypes.SET_DARK_FLAG: {
      return action.flag;
    }
    default: {
      return state;
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/CaseBody/reducers/setDarkBar.js